/**
 * Whether a connection must reach Verified status before it can be submitted, for every project in a
 * program. Mirrors `VerificationSubmissionRequirement` on the backend, carried in the
 * `CONNECTIONS_SUBMISSION_POLICY` program rule's JSONB payload -- its own rule type, not the wizard's
 * `CONNECTIONS_WIZARD`, because this policy applies for the life of the program rather than only while a
 * project is being onboarded.
 */
export enum VERIFICATION_SUBMISSION_REQUIREMENT {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL'
}
